<i18n>
{
  "en": {
    "LearnMoreTitle": "How virtual tours work"
  },
  "de": {
    "LearnMoreTitle": "How virtual tours work"
  }
}
</i18n>
<template>
  <embed-viewer-route-view
    :url="'https://www.youtube.com/embed/kMWxBpM-MSA?autoplay=1&modestbranding=1&playsinline=1'"
    :title="$t('LearnMoreTitle')"
    :can-go-back="canGoBack"
  ></embed-viewer-route-view>
</template>
<script>
export default {
  data() {
    return {
      canGoBack: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = !!from.name;
    });
  }
};
</script>